import React from 'react';

import './MultiInfoSection.scss';

const MultiInfoSection = (props) => (
    <section className="multi-info-section theme-blue">
        <div className="container">
            <div className="row">
                {props.items.map((item, index) => (
                    <div className="col-6 col-md-3" key={index}>
                        <img alt="" src={item.img}/>
                        <p>{item.text}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
)

export default MultiInfoSection;